import GalleryCard from "./GalleryCard";
import { GalleryRowWrapper } from "styles/jss/PhotoGallery.styles";
import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslation } from "next-i18next";
import useWindowSize from "utils/hooks/useWindowSize";
import { FreeMode } from "swiper";
import Link from "next/link";

export default function GalleryRow({ gallery }) {
  const { t } = useTranslation(["common"]);
  const { width } = useWindowSize();

  return (
    <GalleryRowWrapper>
      <Link href={`/photo-gallery/${gallery.slug}`}>
        <h2 className={"name"}>{gallery.name}</h2>
      </Link>
      <Swiper
        slidesPerView={
          width < 376
            ? 1.05
            : width < 599
            ? 1.4
            : width < 900
            ? 2.2
            : width < 1200
            ? 3.05
            : 4
        }
        freeMode={true}
        modules={[FreeMode]}
      >
        {gallery.images.data.slice(0, 3).map(img => (
          <SwiperSlide key={img.id}>
            <GalleryCard {...img.attributes} />
          </SwiperSlide>
        ))}
        <SwiperSlide
          key={gallery.images.data[gallery.images.data.length - 1].id}
        >
          <Link href={`/media-center/photo-gallery/${gallery.slug}`}>
            <a>
              <GalleryCard
                {...gallery.images.data[gallery.images.data.length - 1]
                  .attributes}
                overlay={
                  <div className={"overlay"}>
                    <span className={"see"}>{t("galleryPage.seeMore")}</span>
                  </div>
                }
              />
            </a>
          </Link>
        </SwiperSlide>
      </Swiper>
    </GalleryRowWrapper>
  );
}
